// Story 73 — lets api/axios.js (module scope, outside React) signal
// MaintenanceContext (a React provider) without prop drilling. A 502/503/504
// is an authoritative server signal and trips maintenance immediately; a bare
// network error/timeout is ambiguous (could be the user's own wifi), so it
// only trips after 2 occurrences within a rolling 10s window.
const NETWORK_ERROR_WINDOW_MS = 10000;

const listeners = new Set();
let networkErrorCount = 0;
let lastNetworkErrorAt = 0;

function notify() {
  listeners.forEach((fn) => fn());
}

export function reportUnreachable(kind) {
  if (kind === 'serverDown') {
    notify();
    return;
  }

  const now = Date.now();
  if (now - lastNetworkErrorAt > NETWORK_ERROR_WINDOW_MS) {
    networkErrorCount = 0;
  }
  networkErrorCount += 1;
  lastNetworkErrorAt = now;

  if (networkErrorCount >= 2) {
    notify();
  }
}

export function resetFailureTracking() {
  networkErrorCount = 0;
  lastNetworkErrorAt = 0;
}

export function subscribeMaintenance(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
